// Campus photo for /colleges/butler-university: Public domain, by Nyttend, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AArthur_Jordan_Memorial_Hall%2C_eastern_front.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/butler-university/; credited under the photo.
const photo = {
    "slug": "butler-university",
    "alt": "The eastern front of Jordan Hall across a lawn at Butler University in Indianapolis, Indiana",
    "src": "/colleges/butler-university/campus-1600.webp",
    "srcSmall": "/colleges/butler-university/campus-800.webp",
    "srcMid": "/colleges/butler-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/butler-university/og.jpg",
    "title": "Arthur Jordan Memorial Hall, eastern front",
    "author": "Nyttend",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AArthur_Jordan_Memorial_Hall%2C_eastern_front.jpg",
    "read": "2026-10-01"
};

export default photo;
